/*
 * VNCcommander - The brilliant centerpiece of VNClagoon with your activity stream and much more.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { LoggingInterceptor } from "./logging-interceptor";
import { AuthInterceptor } from "./auth-interceptor";
import { ErrorInterceptor } from "./error.interceptor";
import { environment } from "src/environments/environment";

/** Http interceptor providers in outside-in order */
let providers: any = [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }];
if (!environment.isCordova && !environment.isElectron) {
  providers = [
      { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ];
}
export const httpInterceptorProviders = providers;
